import {
  IMDSToggleButtonGroupItemProps,
  MDSToggleButtonGroupItemSlotName,
} from "./toggle-button-group-item.types";
import { StyledToggleButtonGroupItem } from "./toggle-button-group-item.style";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";

/**
 * MDSToggleButtonGroupItem component for use only within MDSToggleButtonGroup.
 *
 * Supports optional left and right icon slots:
 * ```tsx
 * <MDSToggleButtonGroupItem>
 *   <MDSIcon kind={MDSIconKind.Plus} slot="leftIcon" />
 *   Button Text
 *   <MDSIcon kind={MDSIconKind.Clear} slot="rightIcon" />
 * </MDSToggleButtonGroupItem>
 * ```
 */
export function MDSToggleButtonGroupItem(props: IMDSToggleButtonGroupItemProps) {
  const { children, ariaLabel, ...rest } = props;

  const unslottedChildren = getUnslottedChildren(children);
  const leftIcon = getSlot(children, MDSToggleButtonGroupItemSlotName.LeftIcon);
  const rightIcon = getSlot(children, MDSToggleButtonGroupItemSlotName.RightIcon);

  return (
    <StyledToggleButtonGroupItem {...rest} aria-label={ariaLabel}>
      {leftIcon}
      {unslottedChildren}
      {rightIcon}
    </StyledToggleButtonGroupItem>
  );
}
